import { Typography } from "@mui/material";

interface Props {
  text: string;
}

const InfoText = ({ text }: Props) => {
  return (
    <Typography sx={{ color: "#444444", fontSize: 17, fontWeight: 400 }}>
      {text}
    </Typography>
  );
};

export default InfoText;
